import { useGetGlobalDiscoveryStore } from "@entities/global-discovery/store/useGetGlobalDiscoveryStoreV2";
import { ConfigGlobalTypeSingle } from "@shared/lib/types";
import { Checkbox } from "@shared/ui/Checkbox";
import { ReactNode, useMemo } from "react";
import styles from "./CheckboxFilter.module.scss";

interface CheckboxFilterProps {
  filter: ConfigGlobalTypeSingle;
  children?: ReactNode;
  showTitle?: boolean;
  selectedFilters?: any;
  setSelectedFilter?: (updateFn: (value: any) => any) => void;
}

export function CheckboxFilter({
  filter,
  children,
  showTitle = true,
  selectedFilters: selectedFiltersProp,
  setSelectedFilter: setSelectedFilterProp,
}: CheckboxFilterProps) {
  const globalStore = useGetGlobalDiscoveryStore();
  const selectedFilters = selectedFiltersProp ?? globalStore.selectedFilters;
  const setSelectedFilter = setSelectedFilterProp ?? globalStore.setSelectedFilter;

  // Get current checked state
  const isChecked = useMemo(() => {
    const value = selectedFilters[filter.facetName];
    return Boolean(value);
  }, [selectedFilters, filter.facetName]);

  const handleChange = (e: { target: { checked: boolean } }) => {
    const checked = e.target.checked;

    // Update both filter value and filterTags
    setSelectedFilter((prevFilters) => {
      const newFilters = {
        ...prevFilters,
        [filter.facetName]: checked || undefined,
        filterTags: {
          ...(prevFilters.filterTags || {}),
          [filter.facetName]: checked || undefined,
        },
      };
      return newFilters;
    });
  };

  return (
    <label className={styles.checkboxFilter}>
      <Checkbox checked={isChecked} onChange={handleChange} iconSize={14} />
      {showTitle && (
        <span className={styles.labelText}>
          {filter.title}
          {children}
        </span>
      )}
      {!showTitle && children}
    </label>
  );
}
